import { render, staticRenderFns } from "./configure-structure.vue?vue&type=template&id=bcc1d406&scoped=true"
import script from "./configure-structure.vue?vue&type=script&lang=js"
export * from "./configure-structure.vue?vue&type=script&lang=js"
import style0 from "./configure-structure.vue?vue&type=style&index=0&id=bcc1d406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc1d406",
  null
  
)

export default component.exports